import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  turnOnInventorySyncTitle: {
    id: 'JwHP7K',
    defaultMessage: 'Turn on Inventory Sync',
    description: 'Title for the confirmation modal when turning on inventory sync',
  },
  turnOnInventorySyncMessage: {
    id: '1M2JCK',
    defaultMessage:
      'Activating inventory sync will overwrite existing inventory counts in the selected stores. We recommend reviewing your current data before proceeding.',
    description: 'Warning message for the confirmation modal when turning on inventory sync',
  },
  cancel: {
    id: '8/9Lbg',
    defaultMessage: 'Cancel',
    description: 'Cancel button text for the confirmation modal',
  },
  activateInventorySync: {
    id: 'Z40Tsa',
    defaultMessage: 'Activate Inventory Sync',
    description: 'Confirm button text for the confirmation modal',
  },
  addToDoLater: {
    id: 'd0DIpg',
    defaultMessage: 'Add to "Do Later"',
    description: 'Text for the checkbox to add inventory sync to do later',
  },
  notReadyForInventorySync: {
    id: 'qB+F/d',
    defaultMessage: 'Not ready for Inventory Sync?',
    description: 'Label text asking if user is ready for inventory sync',
  },
});
